import axios from './_nestAxios'

export const getxFechaxMonedaxTipoCambio = (fecha, moneda, tipoTasa) =>
  axios.get(`/tipos-cambio/tasa`, {
    params: { fecha, moneda, tipoTasa }
  })

export const getTiposCambio = fecha =>
  axios.get('/tipos-cambio', {
    params: {
      fecha: fecha
    }
  })

export const actualizarTipoCambio = data => axios.put('/tipos-cambio', data)

export const actualizarTiposCambioViaSunat = fecha =>
  axios.post('/tipos-cambio/actualizar-via-sunat', null, {
    params: {
      fecha: fecha
    }
  })
